import { render, staticRenderFns } from "./asignados.vue?vue&type=template&id=59e38c30&scoped=true&"
import script from "./asignados.vue?vue&type=script&lang=js&"
export * from "./asignados.vue?vue&type=script&lang=js&"
import style0 from "./asignados.vue?vue&type=style&index=0&id=59e38c30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e38c30",
  null
  
)

export default component.exports